import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { TranslateService } from "@root/shared/service/translate.service";
import * as moment from "moment";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import getSymbolFromCurrency from "currency-symbol-map";
import { DateService } from "@root/shared/service/date.service";

@Component({
  selector: "widget-robot-plan-edit-deposit",
  templateUrl: "./deposit.component.html",
  styleUrls: ["./deposit.component.scss"],
})
export class WidgetPlanEditDepositComponent implements OnInit {
  private readonly DetailApi = "/api/automation/deposit/plan_detail";
  private readonly DeleteApi = "/api/automation/deposit/plan_delete";
  private readonly DeducteApi = "/api/deposit/deduct";
  private readonly RefundApi = "/api/deposit/refund";
  @Input() id;
  detail;

  form: UntypedFormGroup = this.fb.group({
    plan_date: null,
    plan_time: null,
  });

  deductForm: UntypedFormGroup = this.fb.group({
    reservation_code: null,
    amount: null,
    paid: null,
    deposit_currency: null,
  });

  get angularDateFormat() {
    return this.dateSrv.getAngularFormat(["YMD"]);
  }

  get timeFormat() {
    return this.dateSrv.getTimeFormatByField("hm");
  }

  constructor(
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    private modal: NzModalService,
    private msg: NzMessageService,
    private t: TranslateService,
    private dateSrv: DateService,
    private modalRef: NzModalRef,
  ) {}

  ngOnInit() {
    this.fetchDetail();
  }

  private fetchDetail() {
    const params = { plan_id: this.id };

    this.http.get(this.DetailApi, { params }).subscribe((rst: any) => {
      this.detail = rst?.data?.record;

      this.form.patchValue({
        ...this.detail,
        plan_date: moment(this.detail.plan_time).toDate(),
        plan_time: moment(this.detail.plan_time).toDate(),
      });
    });
  }

  private requestRefund(code) {
    this.http.post(this.RefundApi, { reservation_code: code }).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        // this.msgSrv.success('押金已退');
        this.msg.success(this.t.t("deposit.list.refund.toast.success"));
        // this.onChange.emit();
        // this.fetchDepositList();
        this.modalRef.destroy();
      }
    });
  }

  requestDeducte() {
    const value = this.deductForm.value;
    if (value.amount < 0) {
      return this.msg.warning(this.t.t("deposit.list.deduct.toast.negative_waring"));
    }

    const params = {
      reservation_code: value.reservation_code,
      amount: value.amount,
    };
    this.http.post(this.DeducteApi, params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("word.success"));
        this.modalRef.destroy();
      }
    });
  }

  requestDelete() {
    const params = { plan_id: this.detail.plan_id };
    this.http.post(this.DeleteApi, params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("word.removed"));
        this.modalRef.destroy();
      }
    });
  }

  onRemove() {
    this.requestDelete();
  }

  displayReturnModal() {
    // this.currentDeposit = data;
    this.modal.confirm({
      // nzTitle: '确认立即退还押金？',
      nzTitle: this.t.t("deposit.list.refund.modal.title"),
      // nzContent: `即将退还押金${data.pending_refund}`,
      nzContent: this.t.t("deposit.list.refund.modal.content", {
        number: getSymbolFromCurrency(this.detail.deposit_currency) + this.detail.pending_refund,
      }),
      nzOnOk: () => this.requestRefund(this.detail.reservation_code),
    });
  }

  displayDeducteModal(tpl) {
    this.deductForm.patchValue({
      reservation_code: this.detail.reservation_code,
      amount: this.detail.deducted || 0,
      paid: this.detail.paid,
      deposit_currency: this.detail.deposit_currency,
    });
    this.modal.create({
      nzTitle: this.t.t("deposit.list.deduct.modal.title"),
      nzContent: tpl,
      nzOkText: this.t.t("word.save"),
      nzOnOk: () => this.requestDeducte(),
    });
  }
}
